module.exports = require('./lib/addons/FluxComponent');



/*****************
 ** WEBPACK FOOTER
 ** ./~/flummox/component.js
 ** module id = 511
 ** module chunks = 0
 **/